import angular from 'angular';
import restangular from 'restangular';

import recoveryPassword from "./recoveryPassword.service";
import labelService from "./label.service";

/*
 * Services definition
 */

const services = angular.module('app.services', ['restangular']);

services.factory("labelService", labelService);
services.factory("recoveryPasswordService", recoveryPassword);

/*
 * Providers configuration stage
 */
services.config((RestangularProvider) => {
		RestangularProvider.setBaseUrl(process.env.NODE_ENV === 'development'
			? 'http://apphmg/senhaop/rest/'
			: '/senhaop/rest/');

		RestangularProvider.setFullResponse(true);
		RestangularProvider.setDefaultHttpFields({timeout: -1});
		RestangularProvider.setDefaultHeaders({'Content-Type': 'application/json'});

		window.addEventListener("message", message => {
			try {
				const deviceInfos = JSON.parse(message.data)
				if(deviceInfos.platform === 'ios' && deviceInfos.tipo && deviceInfos.tipo === 'APP'){
					sessionStorage.setItem('deviceInfos', JSON.stringify(deviceInfos))
				}
			} catch(error){
				console.error("Ocorreu um erro ao tentar recuperar as informações do dispositivo (ios)", error)
			}
	  	});

		document.addEventListener("message", message => {
			try {
				const deviceInfos = JSON.parse(message.data)
				if(deviceInfos.platform === 'android' && deviceInfos.tipo && deviceInfos.tipo === 'APP'){
					sessionStorage.setItem('deviceInfos', JSON.stringify(deviceInfos))
				}
			} catch(error) {
				console.error("Ocorreu um erro ao tentar recuperar as informações do dispositivo (android)", error)
			}
		});

		RestangularProvider.addResponseInterceptor((data, operation, what, url, response, deferred) => {
			let newResponse = {};

			if (data && operation === "getList") {
				newResponse = [];
				newResponse.result = data.result;
			} else {
				newResponse = data;
			}

			return newResponse;
		});
	}
);

/**
 * Pre-Loading Service Data
 */
services.run(function ($http, $state, $stateParams, $rootScope, labelService) {
	labelService.init();

	$rootScope.$on("labelService:labelsChanged", () => {
		$state.transitionTo($state.current, $state.params, {
			reload: true, inherit: false, location: false,
		});
	});
});

export default services.name;



// WEBPACK FOOTER //
// ./src/app/misc/services/services.js